import type { RouteRecordRaw } from 'vue-router'
import { getOldRouteWithRedirect } from '@/utils/oldRouteRedirect'
import { UserSettingsRoutes } from '@/routes/user/settings'

export const oldContactsSettingsRoute: RouteRecordRaw = {
  name: 'user.contacts.settings', // UserSettingsRoutes.ContactsIndex
  path: 'contacts/settings',
  redirect: { name: 'user.contacts.settings.all' },
  children: [
    getOldRouteWithRedirect('user.contacts.settings.all', 'all', UserSettingsRoutes.ContactsAll),
    getOldRouteWithRedirect(
      'user.contacts.settings.unsubscribe-rules',
      'unsubscribe-rules',
      UserSettingsRoutes.ContactsUnsubscribeRules,
    ),
    getOldRouteWithRedirect('user.contacts.settings.sharing', 'sharing', UserSettingsRoutes.ContactsSharing),
    getOldRouteWithRedirect(
      'user.contacts.settings.custom-fields',
      'custom-fields',
      UserSettingsRoutes.ContactsCustomFields,
    ),
  ],
}
